
export function getTimezone(): string {
 
    return Intl.DateTimeFormat().resolvedOptions().timeZone;

}
